import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import Vue from 'vue'
import { sync } from 'vuex-router-sync'

import '@/plugins'
import { RouterLoading } from '@/store/router-loading'
import VueRouteStore from '@/plugins/vue-router-store'
import { notifyUserToReload } from '@/router/chunk-load-error-handler'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'

import App from '@/App'

Vue.use(VueRouteStore, { router, store })

/* eslint-disable no-console */
const _consoleError = console.error
console.error = function () {
  if (process.env.NODE_ENV !== 'development') return

  _consoleError(...arguments)
}
/* eslint-enable no-console */

if (process.env.NODE_ENV !== 'development' || process.env.VUE_APP_USE_SENTRY) {
  Sentry.init({
    Vue,
    dsn: 'https://b5c94ca386294b1f8499f808c8469004@o4503960499519488.ingest.sentry.io/4503960879693824',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'innovationlawlab.org', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    beforeSend (event) {
      // Filter out ResizeObserver loop errors as they are benign
      if (event.exception?.values?.[0]?.value?.includes('ResizeObserver loop completed with undelivered notifications')) {
        return null
      }
      return event
    },
  })
}

window.addEventListener('unhandledrejection', error => {
  if (error.reason.code === 'CSS_CHUNK_LOAD_FAILED') notifyUserToReload(router)
})

Vue.config.productionTip = false

sync(store, router)

// registering router_progress VueX Module
store.registerModule('router_progress', RouterLoading)

// Create Vue instance and append it in the indicated DOM node
const loadApp = _ => {
  const app = new Vue({
    name: 'App',
    store,
    router,
    vuetify,
    render: h => h(App),
  }).$mount()

  document.body.appendChild(app.$el)
}

// Mount the app with fresh data on document [re]load
document.addEventListener('DOMContentLoaded', _ => {
  store.
    dispatch('refreshUserModel').
    then(loadApp).
    catch(loadApp)
})
